export default __webpack_public_path__ + "static/media/angpao-cn.f15df14d.webp";